@if (loading()) {
  @for (item of [].constructor(8); track $index) {
    <div class="order-history-item-skeleton"></div>
  }
} @else if (orders()) {
  @for (order of orders(); track order.code) {
    <sd-order-list-item [routerLink]="['/my-account/orders/offline', order.code]" [order]="order"></sd-order-list-item>
  } @empty {
    <sd-no-orders-block></sd-no-orders-block>
  }

  @if (pagination()?.totalResults > 0) {
    <div class="pagination-wrapper">
      <sd-pagination [pagination]="pagination()" (viewPageEvent)="changePage($event)" [defaultPage]="0"></sd-pagination>
    </div>
  }
}
